/**
 * To add new announcement, simple insert an announcement
 * in the array below.
 *
 * sample announcement object, copy and paste in the array below
 * and change the values accordingly
 * {
 *    type: 'info', // types supported are 'success' | 'info' | 'warning' | 'error' | 'neutral'
 *    message: 'title of the announcement',
 *    description: 'content of the announcement',
 *    actionText: 'text to be shown on button',
 *    actionLink: 'the url where you want user to be redirected upon clicking the action button',
 *    actionTarget: BROWSER.BLANK // optional. supported BROWSER.BLANK (new tab) | BROWSER.SELF (the tab itself)
 * }
 */

import { Announcement } from '@/features/announcement';

export const ANNOUNCEMENTS: Announcement[] = [
  {
    type: 'info',
    message: 'Need your experiment results? Try out GrabX Copilot!',
    description:
      'Ask @GrabX Copilot for results of your experiment, or with any Midas metric to get your results instantly!',
    actionText: 'See Guide',
    actionLink:
      'https://docs.google.com/document/d/1yYni6Xxr7nhcvg8cMY9mLSctYqPNADnTCZiMAwhrbQY/edit#heading=h.5bqvwss7wm3s',
  },
];
